"use client";

import { ChatHeader } from "@/components/chat-header";
import { FeedbackBoard } from "@/components/feedback/FeedbackBoard";

export default function FeedbackPage() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <ChatHeader
        chatId=""
        selectedVisibilityType="public"
        isReadonly={false}
        section="chat"
        title="Feedback"
      />
      <FeedbackBoard />
    </div>
  );
}
